<div class="container-fluid">
    <div class="row align-items-center main-wrapper">
      <div [ngClass]="{'col-12 col-sm-6': showSecondColumn, '': !showSecondColumn}">
        <div>
          <ng-template [ngIf]="view.isLogin">
            <form
              #form="ngForm"
              class="login-form"
              (submit)="form.valid && signIn(loginData)"
            >
              <div class="col-12">
                <div class="login-heading">
                  <span class="subheading">{{ "subheading" | translate }}</span>
                  <span class="welcome-heading">{{
                    "welcomeHeading" | translate
                  }}</span>
                </div>
              </div>
              <div class="col-12">
                <mat-form-field appearance="outline" [hideRequiredMarker]="true">
                  <mat-label
                    >{{ "loginForm.enterUsername" | translate }}
                  </mat-label>
                  <input
                    required
                    (keyup)="errorMessage = ''"
                    matInput
                    class="login-input-text"
                    placeholder="{{ 'loginForm.enterUsername' | translate }}"
                    [(ngModel)]="loginData.email"
                    name="username"
                  />
                </mat-form-field>
              </div>
  
              <div class="col-12">
                <mat-form-field appearance="outline" [hideRequiredMarker]="true">
                  <mat-label
                    >{{ "loginForm.typePassword" | translate }}
                  </mat-label>
                  <input
                    required
                    (keyup)="errorMessage = ''"
                    matInput
                    [type]="hide ? 'text' : 'password'"
                    class="login-input-text"
                    placeholder="{{ 'loginForm.typePassword' | translate }}"
                    [(ngModel)]="loginData.password"
                    name="password"
                  />
                  <button
                    matSuffix
                    (click)="hide = !hide"
                    [attr.aria-label]="'Hide password'"
                    [attr.aria-pressed]="hide"
                    type="button"
                    mat-icon-button
                  >
                    <svg
                      *ngIf="!hide"
                      width="22"
                      height="22"
                      viewBox="0 0 22 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10.0862 13.328C10.3725 13.4404 10.6812 13.5 11 13.5C12.3807 13.5 13.5 12.3807 13.5 11C13.5 10.6812 13.4404 10.3725 13.328 10.0862L10.0862 13.328ZM14.81 8.60425C15.2551 9.31096 15.5 10.1367 15.5 11C15.5 13.4853 13.4853 15.5 11 15.5C10.1367 15.5 9.31096 15.2551 8.60425 14.81L6.60263 16.8116C7.98547 17.5773 9.48878 18 11 18C15.4476 18 20 13.9121 20 11C20 9.7008 18.8434 7.80659 17.0764 6.33781L14.81 8.60425ZM18.496 4.91819C20.6046 6.71959 22 9.0733 22 11C22 15.0675 16.5071 20 11 20C8.94776 20 6.93674 19.3774 5.14077 18.2734L2.51472 20.8995C2.12419 21.29 1.49103 21.29 1.10051 20.8995C0.709981 20.509 0.709981 19.8758 1.10051 19.4853L4.29174 16.2941C4.30004 16.2855 4.30847 16.277 4.31702 16.2688L16.2704 4.31535C16.2787 4.30674 16.2872 4.29831 16.2957 4.29006L19.4853 1.10051C19.8758 0.709986 20.509 0.709986 20.8995 1.10051C21.29 1.49103 21.29 2.1242 20.8995 2.51472L18.496 4.91819ZM12.9541 4.23241C12.3077 4.07881 11.6544 4.00001 11 4.00001C6.55237 4.00001 2 8.08788 2 11C2 11.7266 2.3851 12.7108 3.09762 13.7134C3.41756 14.1635 3.31198 14.7878 2.86181 15.1078C2.41163 15.4277 1.78733 15.3221 1.46739 14.872C0.533766 13.5583 0 12.1941 0 11C0 6.93246 5.49292 2.00001 11 2.00001C11.8125 2.00001 12.6207 2.09751 13.4164 2.28659C13.9538 2.41427 14.2858 2.95337 14.1582 3.49069C14.0305 4.02801 13.4914 4.36009 12.9541 4.23241Z"
                        fill="#797A81"
                      />
                    </svg>
  
                    <svg
                      *ngIf="hide"
                      width="22"
                      height="18"
                      viewBox="0 0 22 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M11 18C5.49292 18 0 13.0675 0 9C0 4.93246 5.49292 0 11 0C16.5071 0 22 4.93246 22 9C22 13.0675 16.5071 18 11 18ZM11 16C15.4476 16 20 11.9121 20 9C20 6.08788 15.4476 2 11 2C6.55237 2 2 6.08788 2 9C2 11.9121 6.55237 16 11 16ZM11 13.5C8.51472 13.5 6.5 11.4853 6.5 9C6.5 6.51472 8.51472 4.5 11 4.5C13.4853 4.5 15.5 6.51472 15.5 9C15.5 11.4853 13.4853 13.5 11 13.5ZM11 11.5C12.3807 11.5 13.5 10.3807 13.5 9C13.5 7.61929 12.3807 6.5 11 6.5C9.61929 6.5 8.5 7.61929 8.5 9C8.5 10.3807 9.61929 11.5 11 11.5Z"
                        fill="#797A81"
                      />
                    </svg>
                  </button>
                </mat-form-field>
              </div>
  
              <div class="col-12" *ngIf="errorMessage">
                <div class="error-message">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10 15C10.2833 15 10.521 14.904 10.713 14.712C10.9043 14.5207 11 14.2833 11 14C11 13.7167 10.9043 13.479 10.713 13.287C10.521 13.0957 10.2833 13 10 13C9.71667 13 9.47933 13.0957 9.288 13.287C9.096 13.479 9 13.7167 9 14C9 14.2833 9.096 14.5207 9.288 14.712C9.47933 14.904 9.71667 15 10 15ZM9 11H11V5H9V11ZM10 20C8.61667 20 7.31667 19.7373 6.1 19.212C4.88333 18.6873 3.825 17.975 2.925 17.075C2.025 16.175 1.31267 15.1167 0.788 13.9C0.262667 12.6833 0 11.3833 0 10C0 8.61667 0.262667 7.31667 0.788 6.1C1.31267 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.31233 6.1 0.787C7.31667 0.262333 8.61667 0 10 0C11.3833 0 12.6833 0.262333 13.9 0.787C15.1167 1.31233 16.175 2.025 17.075 2.925C17.975 3.825 18.6873 4.88333 19.212 6.1C19.7373 7.31667 20 8.61667 20 10C20 11.3833 19.7373 12.6833 19.212 13.9C18.6873 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6873 13.9 19.212C12.6833 19.7373 11.3833 20 10 20ZM10 18C12.2333 18 14.125 17.225 15.675 15.675C17.225 14.125 18 12.2333 18 10C18 7.76667 17.225 5.875 15.675 4.325C14.125 2.775 12.2333 2 10 2C7.76667 2 5.875 2.775 4.325 4.325C2.775 5.875 2 7.76667 2 10C2 12.2333 2.775 14.125 4.325 15.675C5.875 17.225 7.76667 18 10 18Z"
                      fill="#870004"
                    />
                  </svg>
                  <span class="field-required-font">{{ errorMessage }}</span>
                </div>
              </div>
              <div class="col-12">
                <div class="login-action">
                  <button
                    class="login-button"
                    mat-button
                    [disabled]="!form.valid || isLoadingDots"
                    type="submit"
                  >
                    <span class="log-in-button-font" *ngIf="!isLoadingDots">{{ "login" | translate }}</span>
                    <div class="spinner">
                      <div>
                        <mat-spinner
                          *ngIf="isLoadingDots"
                          diameter="20"
                          class="spinner-yellow"
                        ></mat-spinner>
                      </div>
                    </div>
                  </button>
                </div>
              </div>
              <div class="col-12">
                <div
                  class="forgot-password-wrapper"
                  (click)="changeView('isForgotPassword')"
                >
                  <span class="forgot-password-text1">{{
                    "forgotPassword" | translate
                  }}</span>
                </div>
                <div style="margin-top: 8px;"
                  class="forgot-password-wrapper"
                >
                <!-- <div class="no-account-text" style="cursor: default;">You don't have an account?</div>
                  <div (click)="redirectToSignUp()" class="sign-up-here">Sign up here</div> -->
                </div>
              </div>
            </form>
          </ng-template>
          <ng-template [ngIf]="view.isVerify">
            <form class="login-form" (submit)="verifyCode()">
              <div class="login-heading verify-code">
                <span class="subheading">Reset password</span>
                <span class="welcome-heading">Enter verification code</span>
                <span class="forgot-password__subheading subheading"
                  >Check your inbox.</span
                >
              </div>
              <ng-otp-input
                (onInputChange)="onOtpChange($event)"
                [config]="{ length: 6 }"
              ></ng-otp-input>
  
              <div class="error-message" *ngIf="errorMessage">
                {{ errorMessage }}
              </div>
              <div class="login-action">
                <button
                  [promiseBtn]="isLoadingDots"
                  class="login-button"
                  [disabled]="otp.length < 6"
                  mat-button
                  type="submit"
                >
                  Verify
                </button>
              </div>
              <p class="accent-text">
                We have sent you an email. Problems receiving the code?
              </p>
              <div>
                <a
                  style="cursor: pointer"
                  (click)="sendVerificationCode()"
                  class="m-r-20"
                  >Resend Code</a
                >
                <a
                  style="cursor: pointer"
                  (click)="changeView('isForgotPassword')"
                  >Change email</a
                >
              </div>
            </form>
          </ng-template>
  
          <ng-template [ngIf]="view.isForgotPassword">
            <form #form="ngForm" class="login-form">
              <div class="col-12">
                <div class="login-heading">
                  <span class="welcome-heading majorant-font-default">
                    Can't Log in?
                  </span>
                  <span class="forgot-password__subheading subheading mt-16">Enter your username and we’ll send you a verification code to get back into your account.</span>
                </div>
              </div>
  
              <div class="col-12">
                <mat-form-field appearance="outline" [hideRequiredMarker]="true">
                  <mat-label
                    >{{ "loginForm.enterUsername" | translate }}
                  </mat-label>
                  <input
                    required
                    matInput
                    [promiseBtn]="isLoadingDots"
                    (focus)="errorMessage = null"
                    class="login-input-text"
                   
                    [(ngModel)]="loginData.email"
                    name="email"
                  />
                </mat-form-field>
              </div>
  
              <div class="col-12" *ngIf="errorMessage">
                <div class="error-message">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10 15C10.2833 15 10.521 14.904 10.713 14.712C10.9043 14.5207 11 14.2833 11 14C11 13.7167 10.9043 13.479 10.713 13.287C10.521 13.0957 10.2833 13 10 13C9.71667 13 9.47933 13.0957 9.288 13.287C9.096 13.479 9 13.7167 9 14C9 14.2833 9.096 14.5207 9.288 14.712C9.47933 14.904 9.71667 15 10 15ZM9 11H11V5H9V11ZM10 20C8.61667 20 7.31667 19.7373 6.1 19.212C4.88333 18.6873 3.825 17.975 2.925 17.075C2.025 16.175 1.31267 15.1167 0.788 13.9C0.262667 12.6833 0 11.3833 0 10C0 8.61667 0.262667 7.31667 0.788 6.1C1.31267 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.31233 6.1 0.787C7.31667 0.262333 8.61667 0 10 0C11.3833 0 12.6833 0.262333 13.9 0.787C15.1167 1.31233 16.175 2.025 17.075 2.925C17.975 3.825 18.6873 4.88333 19.212 6.1C19.7373 7.31667 20 8.61667 20 10C20 11.3833 19.7373 12.6833 19.212 13.9C18.6873 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6873 13.9 19.212C12.6833 19.7373 11.3833 20 10 20ZM10 18C12.2333 18 14.125 17.225 15.675 15.675C17.225 14.125 18 12.2333 18 10C18 7.76667 17.225 5.875 15.675 4.325C14.125 2.775 12.2333 2 10 2C7.76667 2 5.875 2.775 4.325 4.325C2.775 5.875 2 7.76667 2 10C2 12.2333 2.775 14.125 4.325 15.675C5.875 17.225 7.76667 18 10 18Z"
                      fill="#870004"
                    />
                  </svg>
                  <span class="error-font">{{ errorMessage }}</span>
                </div>
              </div>
  
              <div class="col-12">
                <div class="login-action">
                  <button
                    (click)="sendVerificationCode()"
                    [disabled]="!form.valid"
                    class="login-button"
                    mat-button
                    type="submit"
                  >
                    {{ "Send verification code" | translate }}
                  </button>
                </div>
              </div>
              <div class="col-12">
                <div
                  class="forgot-password-wrapper"
                  (click)="changeView('isLogin')"
                >
                  <span class="forgot-password-text">Go back to Login page</span>
                </div>
              </div>
            </form>
          </ng-template>
  
          <ng-template [ngIf]="view.isNewPassword">
            <form class="login-form" (submit)="changePassword(loginData)">
              <div class="col-12">
                <div class="login-heading">
                  <span class="welcome-heading">{{
                    "newPassword" | translate
                  }}</span>
                  <span class="forgot-password__subheading">{{
                    "oneMoreStep" | translate
                  }}</span>
                </div>
              </div>
              <div class="col-12">
                <mat-form-field appearance="outline" [hideRequiredMarker]="true">
                  <mat-label
                    >{{ "loginForm.typeNewPassword" | translate }}
                  </mat-label>
                  <input
                    (keyup)="errorMessage = ''"
                    required
                    matInput
                    [promiseBtn]="changingPassword"
                    #newPasswordInput="ngModel"
                    type="password"
                    class="new-password-input-text"
                    placeholder="{{ 'loginForm.typeNewPassword' | translate }}"
                    [(ngModel)]="loginData.password"
                    [ngModelOptions]="{ standalone: true }"
                    [type]="showPassword ? 'text' : 'password'"
                  />
                  <button
                    matSuffix
                    (click)="hide = !hide"
                    [attr.aria-label]="'Hide password'"
                    [attr.aria-pressed]="hide"
                    type="button"
                    mat-icon-button
                  >
                    <mat-icon matSuffix (click)="togglePasswordVisibility()">
                      {{ showPassword ? "visibility_off" : "visibility" }}
                    </mat-icon>
                  </button>
                </mat-form-field>
              </div>
              <div class="col-12">
                <mat-form-field appearance="outline" [hideRequiredMarker]="true">
                  <mat-label
                    >{{ "loginForm.confirmYourPassword" | translate }}
                  </mat-label>
                  <input
                    (keyup)="errorMessage = ''"
                    required
                    #confirmPasswordInput="ngModel"
                    matInput
                    [type]="showConfirmPassword ? 'text' : 'password'"
                    class="new-password-input-text"
                    placeholder="{{
                      'loginForm.confirmYourPassword' | translate
                    }}"
                    [(ngModel)]="loginData.confirmPassword"
                    [ngModelOptions]="{ standalone: true }"
                  />
                  <button
                    matSuffix
                    (click)="hide = !hide"
                    [attr.aria-label]="'Hide password'"
                    [attr.aria-pressed]="hide"
                    type="button"
                    mat-icon-button
                  >
                    <mat-icon
                      matSuffix
                      (click)="toggleConfirmPasswordVisibility()"
                    >
                      {{ showConfirmPassword ? "visibility_off" : "visibility" }}
                    </mat-icon>
                  </button>
                </mat-form-field>
              </div>
  
              <div class="col-12" *ngIf="errorMessage">
                <div class="error-message">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10 15C10.2833 15 10.521 14.904 10.713 14.712C10.9043 14.5207 11 14.2833 11 14C11 13.7167 10.9043 13.479 10.713 13.287C10.521 13.0957 10.2833 13 10 13C9.71667 13 9.47933 13.0957 9.288 13.287C9.096 13.479 9 13.7167 9 14C9 14.2833 9.096 14.5207 9.288 14.712C9.47933 14.904 9.71667 15 10 15ZM9 11H11V5H9V11ZM10 20C8.61667 20 7.31667 19.7373 6.1 19.212C4.88333 18.6873 3.825 17.975 2.925 17.075C2.025 16.175 1.31267 15.1167 0.788 13.9C0.262667 12.6833 0 11.3833 0 10C0 8.61667 0.262667 7.31667 0.788 6.1C1.31267 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.31233 6.1 0.787C7.31667 0.262333 8.61667 0 10 0C11.3833 0 12.6833 0.262333 13.9 0.787C15.1167 1.31233 16.175 2.025 17.075 2.925C17.975 3.825 18.6873 4.88333 19.212 6.1C19.7373 7.31667 20 8.61667 20 10C20 11.3833 19.7373 12.6833 19.212 13.9C18.6873 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6873 13.9 19.212C12.6833 19.7373 11.3833 20 10 20ZM10 18C12.2333 18 14.125 17.225 15.675 15.675C17.225 14.125 18 12.2333 18 10C18 7.76667 17.225 5.875 15.675 4.325C14.125 2.775 12.2333 2 10 2C7.76667 2 5.875 2.775 4.325 4.325C2.775 5.875 2 7.76667 2 10C2 12.2333 2.775 14.125 4.325 15.675C5.875 17.225 7.76667 18 10 18Z"
                      fill="#870004"
                    />
                  </svg>
                  <span class="field-required-font">{{ errorMessage }}</span>
                </div>
              </div>
              <a
                style="margin-left: 16px; cursor: pointer"
                *ngIf="isWrongCode == true"
                (click)="goBackToEnteringCodeScreen()"
                >Go back and enter valid code.</a
              >
  
              <div class="col-12">
                <div class="login-action">
                  <button class="login-button" mat-button type="submit">
                    {{ "changePassword" | translate }}
                  </button>
                </div>
              </div>
            </form>
          </ng-template>
        </div>
      </div>
  
      <div *ngIf="showSecondColumn" class="col-12 col-sm-6 image-wrapper" style="display: flex; justify-content: center; align-items: center;">
        <div style="display: flex; flex-direction: column; align-items: center;">
          <img
            height="16"
            width="175"
            [src]="logoUrl"
            style="max-width: 60%; margin-bottom: 40px;"
            class="img-fluid"
          />
          <img
            src="/assets/images/loginNoLogo.svg"
            style="max-width: 87%"
            class="img-fluid"
          />
        </div>
      </div>
    </div>
  </div>
  